import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import ContentContainer from '../../content/ContentContainer/ContentContainer'
import ContentCover from '../../content/ContentCover/ContentCover'
import { ProductCard } from '../ProductCard/ProductCard'

// To optimize LCP we mark the first product card as eager so the image gets loaded faster
export function ProductListing({ products = [], collection = [] }) {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_id: collection.id,
          item_list_name: collection.title,
          items: products.map((product, index) => ({
            item_id: product.shopifyId,
            item_name: product.title,
            index: index,
            item_category: product.productType,
            item_list_id: collection.id,
            item_list_name: collection.title,
            item_variant: product.variants[0]?.id,
            price: product.variants[0]?.price,
          })),
        },
      })
    }
  }, [products])

  return (
    <ContentCover>
      <ContentContainer>
        <Row>
          {products.map((p, index) => (
            <Col className='px-0 py-2' key={p.id}>
              <ProductCard product={p} key={p.id} eager={index === 0} />
            </Col>
          ))}
        </Row>
      </ContentContainer>
    </ContentCover>
  )
}
